import { useColorModeValue } from '@chakra-ui/react';

export const useColors = () => {
  const backgroundCardColor = useColorModeValue('white', 'whiteAlpha.100');
  const borderColor = useColorModeValue('gray.200', 'gray.600');
  const textColor = useColorModeValue('gray.700', 'white');
  const secondaryTextColor = useColorModeValue('gray.500', 'gray.400');
  const inputColor = useColorModeValue('white', 'gray.700');

  return {
    backgroundCardColor,
    secondaryTextColor,
    textColor,
    borderColor,
    inputColor,
  };
};
